const ChatWarningIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2L2 22h20L12 2zm0 3.3L19.7 19H4.3L12 5.3zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z" />
  </svg>
);

export default ChatWarningIcon;
